import { useContext } from 'react';
import { OptimizelyContext } from 'lib/optimizely/optimizely';
import { OptimizelyContextValue } from 'lib/optimizely/optimizely.types';

type CampaignConfig = {
  excludeTargetLocation: boolean;
  addressPropertyKey: string;
  targetLocation: string[];
  pointsDisclaimerSymbol: string;
  promotionalSashMessage: string;
};

interface Result {
  isStandardCampaignEnabled: boolean;
  message?: string;
  additionalTermsAndConditions?: string;
  priceMessages?: string;
  replaceQffFinalTerms?: boolean;
  termsAndConditions?: string;
  title?: string;
  isGeoTargeted?: boolean;
  campaignGeoConfig?: CampaignConfig;
}

const FEATURE_FLAG_NAME = 'qantas-hotels-blue-banner-message';

const useStandardCampaign = (): Result => {
  const optimizelyContext = useContext(OptimizelyContext) as OptimizelyContextValue;
  const decision = optimizelyContext?.decisions?.[FEATURE_FLAG_NAME];

  const isReady = optimizelyContext?.isReady ?? false;
  const { enabled = false, variables } = decision || {};

  if (!isReady) {
    return {
      isStandardCampaignEnabled: false,
      message: undefined,
      additionalTermsAndConditions: undefined,
      priceMessages: undefined,
      replaceQffFinalTerms: false,
      termsAndConditions: undefined,
      title: undefined,
    };
  }

  return {
    isStandardCampaignEnabled: enabled,
    message: variables?.message,
    additionalTermsAndConditions: variables?.additionalTermsAndConditions,
    priceMessages: variables?.priceMessages,
    replaceQffFinalTerms: variables?.replaceQffFinalTerms,
    termsAndConditions: variables?.termsAndConditions,
    title: variables?.title,
    isGeoTargeted: variables?.isGeoTargeted,
    campaignGeoConfig: variables?.campaignGeoConfig,
  };
};

export default useStandardCampaign;
